import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/admin/users', icon: 'bi-people-fill', label: 'Utilisateurs' },
  { to: '/admin/annonces', icon: 'bi-megaphone-fill', label: 'Annonces' },
  { to: '/admin/reservations', icon: 'bi-calendar-check-fill', label: 'Réservations' },
  { to: '/admin/paiements', icon: 'bi-credit-card-fill', label: 'Paiements' },
  { to: '/admin/signalements', icon: 'bi-flag-fill', label: 'Signalements' },
];

function SideBarAdmin() {
  const { pathname } = useLocation();
  return (
    <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
      <div className="card-header bg-dark text-white py-2 px-3">
        <p className="mb-0 fw-semibold" style={{ fontSize: 13 }}>
          <i className="bi bi-shield-lock-fill me-2"></i>Administration
        </p>
      </div>
      <ul className="list-group list-group-flush">
        {LINKS.map(({ to, icon, label }) => {
          const active = pathname.startsWith(to);
          return (
            <li key={to} className="list-group-item p-0">
              <Link
                to={to}
                className={`d-flex align-items-center gap-2 px-3 py-2 text-decoration-none ${active ? 'bg-primary bg-opacity-10 text-primary fw-semibold' : 'text-body-secondary'}`}
                style={{ fontSize: 13 }}
              >
                <i className={`bi ${icon}`} style={{ width: 16, textAlign: 'center' }}></i>
                {label}
                {active && <i className="bi bi-chevron-right ms-auto" style={{ fontSize: 10 }}></i>}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SideBarAdmin;
